import React from 'react'
import Website1 from './website-1/Website1'

const App = () => {
  return (
    <>
      <Website1/>
    </>
  )
}

export default App